import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/products'

export default {

  async search (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/search', criterias, { headers: headers })
  },

  async detail (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/detail', criterias, { headers: headers })
  },

  async create (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/import', criterias, { headers: headers })
  },

  async extract (file) {
    const headers = await getHeaders()
    return axios.post(prefix + '/extract', file, { headers: headers })
  },

  async export () {
    const headers = await getHeaders()
    return axios.get(prefix + '/export', { responseType: 'blob', headers: headers })
  },

  async structure () {
    const headers = await getHeaders()
    return axios.get(prefix + '/structure', { headers: headers })
  },

  async createProduct (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/create', criterias, { headers: headers })
  },

  async updateProduct (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/update', criterias, { headers: headers })
  },

  async createdProductsLastMonth () {
    const headers = await getHeaders()
    return axios.get(prefix + '/createdProductsLastMonth', { headers: headers })
  },

  async createdProductsCurrentMonth () {
    const headers = await getHeaders()
    return axios.get(prefix + '/createdProductsCurrentMonth', { headers: headers })
  },

  async editedProductsLastMonth () {
    const headers = await getHeaders()
    return axios.get(prefix + '/editedProductsLastMonth', { headers: headers })
  },

  async editedProductsCurrentMonth () {
    const headers = await getHeaders()
    return axios.get(prefix + '/editedProductsCurrentMonth', { headers: headers })
  }
}
